module.exports = __webpack_public_path__ + "static/media/whatsapp.3693a754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/whatsapp.png
// module id = 34
// module chunks = 0